module.exports = __webpack_public_path__ + "img/ie.1b45bace.svg";